import { Stack, Avatar, Button, Typography, Card, CardContent, styled } from '@mui/material';
import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { getCke } from '../../../helper/cookieHelper';
import { updateInviteRequest } from '../../../service/invite.service';
import { fDateTime } from '../../../utils/formatTime';
import Iconify from '../../../fl-components/Iconify';
import RejectRequestModal from '../Modal/RejectRequestModal';

const IconStyle = styled(Iconify)(({ theme }) => ({
  width: 20,
  height: 20,
  // marginTop: 1,
  flexShrink: 0,
  marginRight: theme.spacing(2)
}));

export default function PendingRequestCard({ userDetail, requestData, removeRequest }) {
  const [btnLoading, setBtnLoading] = useState();
  // Reject modal state
  const [isModalOpen, setOpenModal] = useState(false);
  // Reject modal button loading state
  const [modalBtnLoading, setModalBtnLoading] = useState(false);
  // Reject request note
  const [note, setNote] = useState('');
  const { enqueueSnackbar } = useSnackbar();

  const handleAccept = async () => {
    setBtnLoading(true);
    const obj = {
      approverUserId: getCke('userId'),
      requesterStatus: 'accepted'
    };
    const res = await updateInviteRequest(requestData?.id, obj);
    if (res) {
      if (res?.statusCode && res?.statusCode !== 200)
        enqueueSnackbar('Please try again later', {
          variant: 'error'
        });
      else {
        removeRequest(requestData?.id);
        enqueueSnackbar('Request Accepted', {
          variant: 'success'
        });
      }
    }
    setBtnLoading(false);
  };

  const handleReject = async () => {
    setModalBtnLoading(true);
    const obj = {
      approverUserId: getCke('userId'),
      requesterStatus: 'rejected'
    };
    if (note.trim() !== '') obj.approverNotes = note;
    const res = await updateInviteRequest(requestData?.id, obj);
    if (res) {
      if (res?.statusCode && res?.statusCode !== 200)
        enqueueSnackbar('Please try again later', {
          variant: 'error'
        });
      else {
        removeRequest(requestData?.id);
        setOpenModal(false);
        enqueueSnackbar('Request Rejected', {
          variant: 'success'
        });
      }
    }
    setModalBtnLoading(false);
  };

  return (
    <Stack sx={{ position: 'relative' }}>
      <Card>
        <CardContent>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar alt={userDetail?.fullName} src={userDetail?.profileImage} />
            <div>
              <Typography variant="subtitle2">{userDetail?.fullName}</Typography>
              <Typography
                variant="caption"
                sx={{ color: 'text.secondary', mt: 0.5, display: 'block' }}
              >
                Requested at {fDateTime(requestData?.createdAt)}
              </Typography>
            </div>
          </Stack>
          {/* <Typography variant="body1" sx={{ marginTop: '10px' }}>
              Class Details
            </Typography> */}
          <Stack direction="row" alignItems="center" sx={{ marginTop: '10px' }}>
            <IconStyle icon="eva:checkmark-circle-2-fill" />
            <Typography variant="body2" textTransform="capitalize">
              {requestData.classId?.name}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" sx={{ marginTop: '10px' }}>
            <IconStyle icon="eva:checkmark-circle-2-fill" />
            <Typography variant="body2" textTransform="capitalize">
              {requestData.classId?.category}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" sx={{ marginTop: '10px' }}>
            <IconStyle icon="ic:round-business-center" />
            <Typography variant="body2" textTransform="capitalize">
              {requestData.classId?.subject}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={2} alignItems="flex-end" sx={{ marginTop: '10px' }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => handleAccept()}
              endIcon={<Iconify icon="eva:checkmark-circle-2-fill" />}
              disabled={btnLoading}
            >
              Accept
            </Button>

            <Button
              fullWidth
              variant="contained"
              color="error"
              disabled={btnLoading}
              onClick={() => setOpenModal(true)}
              endIcon={<Iconify icon="eva:close-circle-fill" />}
            >
              Reject
            </Button>
          </Stack>
        </CardContent>
      </Card>

      {/* When reject request then we double check to delete request */}
      <RejectRequestModal
        open={isModalOpen}
        onClose={() => setOpenModal(false)}
        value={note}
        onChange={setNote}
        isDataSubmitting={modalBtnLoading}
        onAction={() => handleReject()}
        onCancel={() => setOpenModal(false)}
      />
    </Stack>
  );
}

PendingRequestCard.propTypes = {
  userDetail: PropTypes.shape({
    fullName: PropTypes.string,
    profileImage: PropTypes.string
  }),
  requestData: PropTypes.shape({
    classId: PropTypes.string,
    id: PropTypes.string,
    _id: PropTypes.string,
    createdAt: PropTypes.string
  }),
  removeRequest: PropTypes.func
};
